import { CommonConstants } from "../../common/constants/common-constants";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import { HTTPService } from "../../common/services/httpService";
import { IAbhyasaBharathiFile, IAbhyasaBharathiFileDeleteRequest } from "./abhyasaBharathiModels";

const httpService = new HTTPService();
const fileUpload = (filterId: number,academicYear:string, files: File[]): Promise<IHTTPResponse<IAPIResponse<any>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.AbhyasaBharathiFileUpload
        }`;
    const formData = new FormData();
    files.forEach((file) => { formData.append('files', file) }); 
    formData.append('filterId', filterId.toString());
    formData.append('academicYear', academicYear);
    return httpService.fileUpload(url, formData);
};

const getFiles = (academicYear: string): Promise<IHTTPResponse<IAPIResponse<IAbhyasaBharathiFile>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.AbhyasaBharathiFiles}/${academicYear}`;
    return httpService.get(url);
}

const deleteFile = (deleteFileRequest: IAbhyasaBharathiFileDeleteRequest): Promise<IHTTPResponse<IAPIResponse<IAbhyasaBharathiFile>>> => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.AbhyasaBharathiDeleteFile}`;

    return httpService.post(url, deleteFileRequest);
}

const getFileDownloadUrl = (fileId: number): string => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.AbhyasaBharathiDownloadFile}/${fileId}`;

    return url;
}

const AbhyasaBharathiService = {
    fileUpload,
    getFiles,
    deleteFile,
    getFileDownloadUrl
};

export default AbhyasaBharathiService;